module.exports = __webpack_public_path__ + "media/images/classroom-3f3aa419.jpg";